import "./index.css";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { App } from "./app";
import i18next from "./i18next/i18next";
import { Analytics } from "./providers/analytics";

const { DEV, VITE_ENVIRONMENT, VITE_VERSION } = import.meta.env;

if (!DEV) {
  const clientId = new URLSearchParams(window.location.search).get("token");
  Sentry.init({
    dsn: "https://e3b0a62e30954ab683c608f295d486fc@o47002.ingest.sentry.io/4505475833462784",
    release: VITE_VERSION,
    environment: VITE_ENVIRONMENT,
    initialScope: {
      tags: {
        app: "side-bar",
        clientId: clientId,
      },
    },
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <Analytics>
        <App />
      </Analytics>
    </I18nextProvider>
  </React.StrictMode>
);
